<script lang="ts">
	import type { ProductForCard } from "@components/ProductCard.js";
	import ProductCard from "@components/ProductCard.svelte";
	import Carousel from "@components/common/Carousel.svelte";
	import Heading from "@components/common/Heading.svelte";
	import Icon from "@components/common/Icon.svelte";
	import type { EmblaCarouselType } from "embla-carousel";
	import type { ClassValue } from "svelte/elements";
	import arrowIcon from "@core/assets/icons/arrow.svg?raw";
	import type { SubcategoryForCustomer } from "@core/schema/Subcategory.js";
	import { idFromAnchor } from "@core/schema/utils/idFromAnchor.js";

	const {
		products,
		title,
		class: customClass,
		anchor,
		subcategories,
	}: {
		products: ProductForCard[];
		title: string;
		subcategories: SubcategoryForCustomer[];
		class?: ClassValue;
		anchor?: string;
	} = $props();

	let canNext = $state(false);
	let canPrev = $state(false);

	let api = $state<EmblaCarouselType>();
</script>

{#if products.length > 0}
	<section
		class={["py-14 sm:py-17 md:py-20 lg:py-23 xl:py-26 full-width grid-container", customClass]}
		id={idFromAnchor(anchor)}
	>
		<div class="flex justify-between mb-9 md:mb-15 items-center">
			<Heading level={2} class=" text-fcrdarkgray heading-2" text={title} />
			<div class={["hidden gap-2 text-fcrdarkgray", (canNext || canPrev) && "lg:flex"]}>
				<button
					type="button"
					class={[
						"size-16 flex items-center bg-white justify-center border-fcrlightgray-300 disabled:opacity-50 border rounded-full",
						"[&:not(:disabled):hover:active]:scale-95 transition duration-150 ease-in-out",
						"[&:not(:disabled):hover]:border-fcrdarkgray",
					]}
					onclick={(): void => {
						api?.scrollPrev();
					}}
					disabled={!canPrev}
				>
					<Icon icon={arrowIcon} class="size-4.5 rotate-180" />
				</button>
				<button
					type="button"
					class={[
						"size-16 flex items-center bg-white justify-center border-fcrlightgray-300 disabled:opacity-50 border rounded-full",
						"[&:not(:disabled):hover:active]:scale-95 transition duration-150 ease-in-out",
						"[&:not(:disabled):hover]:border-fcrdarkgray",
					]}
					onclick={(): void => {
						api?.scrollNext();
					}}
					disabled={!canNext}
				>
					<Icon icon={arrowIcon} class="size-4.5 " />
				</button>
			</div>
		</div>
		<Carousel
			bind:canNext
			bind:canPrev
			bind:api
			items={products}
			class="full-width"
			alignWithGridContainer
			itemsContainerClass="gap-4"
			options={{ dragFree: true }}
		>
			{#snippet item(product: ProductForCard)}
				{@const subcategory = subcategories.find(({ id }) => id === product.subcategoryId)}
				{#if subcategory}
					<ProductCard {product} {subcategory} />
				{/if}
			{/snippet}
		</Carousel>
	</section>
{/if}
